import { useState, useEffect } from "react";

const useNewProds = (selectedLanguage) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `https://backend-theta-gold-17.vercel.app/campanhaAtual`
        );
        const data = await response.json();
        setProducts(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      }
    };

    fetchProducts();
  }, [selectedLanguage]);

  return products;
};

export default useNewProds;